import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IDeductionItem, defaultValue } from 'app/shared/model/deduction-item.model';
// 请求
export const ACTION_TYPES = {
  FETCH_DEDUCTIONITEM_LIST: 'deductionItem/FETCH_DEDUCTIONITEM_LIST',
  FETCH_DEDUCTIONITEM: 'deductionItem/FETCH_DEDUCTIONITEM',
  CREATE_DEDUCTIONITEM: 'deductionItem/CREATE_DEDUCTIONITEM',
  UPDATE_DEDUCTIONITEM: 'deductionItem/UPDATE_DEDUCTIONITEM',
  DELETE_DEDUCTIONITEM: 'deductionItem/DELETE_DEDUCTIONITEM',
  RESET: 'deductionItem/RESET'
};
// state
const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IDeductionItem>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false
};

export type DeductionItemState = Readonly<typeof initialState>;

// Reducer

export default (state: DeductionItemState = initialState, action): DeductionItemState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_DEDUCTIONITEM_LIST):
    case REQUEST(ACTION_TYPES.FETCH_DEDUCTIONITEM):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_DEDUCTIONITEM):
    case REQUEST(ACTION_TYPES.UPDATE_DEDUCTIONITEM):
    case REQUEST(ACTION_TYPES.DELETE_DEDUCTIONITEM):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_DEDUCTIONITEM_LIST):
    case FAILURE(ACTION_TYPES.FETCH_DEDUCTIONITEM):
    case FAILURE(ACTION_TYPES.CREATE_DEDUCTIONITEM):
    case FAILURE(ACTION_TYPES.UPDATE_DEDUCTIONITEM):
    case FAILURE(ACTION_TYPES.DELETE_DEDUCTIONITEM):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_DEDUCTIONITEM_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_DEDUCTIONITEM):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_DEDUCTIONITEM):
    case SUCCESS(ACTION_TYPES.UPDATE_DEDUCTIONITEM):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_DEDUCTIONITEM):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/deduction-items';

// Actions

export const getEntities: ICrudGetAllAction<IDeductionItem> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_DEDUCTIONITEM_LIST,
  payload: axios.get<IDeductionItem>(`${apiUrl}?cacheBuster=${new Date().getTime()}`)
});

export const getEntity: ICrudGetAction<IDeductionItem> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_DEDUCTIONITEM,
    payload: axios.get<IDeductionItem>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<IDeductionItem> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_DEDUCTIONITEM,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IDeductionItem> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_DEDUCTIONITEM,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity: ICrudDeleteAction<IDeductionItem> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_DEDUCTIONITEM,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
